// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".event-card[data-v-908c6e8a]{-ms-flex-wrap:nowrap;flex-wrap:nowrap}", "",{"version":3,"sources":["webpack://./resources/assets/js/online_booking/new/components/events/SingleEvent.vue"],"names":[],"mappings":"AACA,6BACI,oBAAA,CAAA,gBAAJ","sourcesContent":["\n.event-card {\n    flex-wrap: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
